<template>
  <div>
    <h5 class="mb-2">Translations</h5>
    <div class="row">
      <div
        class="col-lg-6 col-xl-4 align-self-center mb-4"
        v-for="(language, langIndex) in languagesToShow"
        :key="langIndex"
      >
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              type="text"
              name="en-trans"
              v-model="translationValue[language.iso_2]"
              placeholder="."
            />
            <label>{{ language.lang_name }}</label>
          </div>
          <!-- <Tooltip :title="`Enter ${language.lang_name} Translation`" /> -->
        </div>
        <!-- <p class="error_message">
          <span
            v-if="submitted && errors.has(item.fieldname)"
          >{{ errors.first(`${item.fieldname}`) }}</span>
        </p> -->
      </div>

      <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              type="text"
              name="de-trans"
              v-model="translationsObj.de"
              placeholder="."
            />
            <label>German</label>
          </div>
          <Tooltip :title="`Enter German Translation`"  />
        </div>
      </div>

      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              type="text"
              name="fr-trans"
              v-model="translationsObj.fr"
              placeholder="."
            />
            <label>French</label>
          </div>
          <Tooltip :title="`Enter English Translation`"  />
        </div>
      </div>

      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              type="text"
              name="it-trans"
              v-model="translationsObj.it"
              placeholder="."
            />
            <label>Italian</label>
          </div>
          <Tooltip :title="`Enter Italian Translation`"  />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    translationsObj: {
      type: Object,
      default: () => ({}),
    },
    skip: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getGlobalOptions"]),
    translationValue() {
      let extraLangs = null;
      if (this.translationsObj.extraLangs) {
        try {
          extraLangs = JSON.parse(this.translationsObj.extraLangs);
        } catch (e) {
          extraLangs = null;
        }

        if (extraLangs) {
          Object.keys(extraLangs).forEach((l) => {
            this.translationsObj[l] = extraLangs[l] || null;
          });
        }
      }

      return this.translationsObj;
    },
    languagesToShow: function () {
      let languages = [];
      if (this.getGlobalOptions && this.getGlobalOptions.length > 0) {
        let kiosk_langs_obj = this.getGlobalOptions.find(
          (x) => x.go_key === "KIOSK_LANGUAGE"
        );

        if (kiosk_langs_obj) {
          try {
            let kiosk_langs = JSON.parse(kiosk_langs_obj.go_value);

            if (kiosk_langs && kiosk_langs.length > 0) {
              languages = kiosk_langs
                .filter((x) => x.lang_name && x.iso_2)
                .map((x) => ({
                  lang_name: x.lang_name,
                  iso_2: x.iso_2.toLowerCase(),
                }));
            }
          } catch (err) {
            console.log("error in parsing kiosk languages");
          }
        }
      }

      console.log("languagesToShow =>>> ", languages);

      if (this.skip && this.skip.length > 0) {
        languages = languages.filter((l) => !this.skip.includes(l.iso_2));
      }

      return languages;
    },
  },
  mounted: function () {
    this.fetchGlobalOptions();
  },
  methods: {
    ...mapActions(["fetchGlobalOptions"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/translationsFields.vue